import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAuthState } from "features/auth/model/authSlice";
import { AppDispatch } from "shared/store/root.store";
import { Paths } from "shared/config/paths";
import { Login } from "pages/login/Login";
import { Layout } from "widgets/layout/Layout";
import AllServicesPage from "pages/allServicesPage/allServicesPage";
import AllHandbooksPage from "pages/allHandbooksPage/allHandbooksPage";
import { ProtectedRoute } from "features/auth/ui/ProtectedRoute";
import HandbookPage from "pages/handbooks/HandBookPage";
import SelectHandbookPage from "pages/selectHandbook/SelectHandbookPage";

function App() {
  const { isLoggedIn } = useSelector(getAuthState);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get("token");

    if (tokenFromUrl && !isLoggedIn) {
      console.log("Найден токен в URL, выполняю авторизацию...");

      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }, [dispatch, isLoggedIn]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path={Paths.login} element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="all-services" replace />} />
          <Route path="all-services" element={<AllServicesPage />} />
          <Route path="all-handbooks" element={<AllHandbooksPage />} />
          {/* Сервис выбран, справочник — ещё нет. */}
          <Route path=":service" element={<SelectHandbookPage />} />
          <Route path=":service/:resource" element={<HandbookPage />} />
        </Route>

        {/* fallback */}
        <Route path="*" element={<Navigate to={Paths.login} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
